import React from "react";
import "../concise-copy.css";

export const CopyDetails = ({ id, title, children, tone }) => (
  <details className="copy-details" style={tone === "light" ? { color: "var(--ols-navy)" } : undefined} data-testid={`${id}-details`}>
    <summary data-testid={`${id}-summary`}>{title}</summary>
    <div className="copy-details__body" data-testid={`${id}-content`}>{children}</div>
  </details>
);